import { Phone } from '@mui/icons-material';
import { formatTranslation } from 'intl';
import { UserTranslationKeys } from 'intl/keys';
import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { iconButtonStyle } from './styles';

export const CallByPhoneIcon = ({
  phone,
}: {
  phone: string;
}): React.ReactElement => {
  const intl = useIntl();
  const tooltipTitle = phone
    ? formatTranslation(intl, UserTranslationKeys.call)
    : formatTranslation(intl, UserTranslationKeys.noPhoneNumber);
  return (
    <Tooltip title={tooltipTitle}>
      <Box>
        <IconButton
          color='inherit'
          size='medium'
          disabled={!phone}
          sx={iconButtonStyle}
          onClick={() => (window.location.href = `tel:${phone}`)}
        >
          <Phone fontSize='small' />
        </IconButton>
      </Box>
    </Tooltip>
  );
};
